var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"d-block d-md-none",attrs:{"show":_vm.show,"no-wrap":"","fixed":"","opacity":"0.70"},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }